var Definition = /** @class */ (function () {
    function Definition(id, defaultLocale, actions, routes) {
        this.id = id;
        this.defaultLocale = defaultLocale;
        this.actions = actions;
        this.routes = routes;
    }
    Definition.prototype.routeWithId = function (id) {
        return Array.from(this.routes.values()).find(function (route) { return route.id === id; });
    };
    return Definition;
}());
export default Definition;
//# sourceMappingURL=definition.js.map